import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Ryd evt. gammelt token fra localStorage (sessionen er nu udelukkende cookie-baseret)
try { localStorage.removeItem("bsm_token"); } catch (e) {}

const api = axios.create({ baseURL: API, withCredentials: true });

let refreshPromise = null;
export function refreshSession() {
  if (!refreshPromise) {
    refreshPromise = axios.post(`${API}/auth/refresh`, {}, { withCredentials: true })
      .then((r) => r.data)
      .finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
}

const NO_RETRY = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/logout-all"];

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status !== 401 || !cfg || cfg._retried || NO_RETRY.some((p) => url.includes(p))) {
      return Promise.reject(error);
    }
    try {
      await refreshSession();
    } catch (e) {
      window.dispatchEvent(new Event("bsm:session-expired"));
      return Promise.reject(error);
    }
    cfg._retried = true;
    return api(cfg);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Der opstod en fejl. Prøv igen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
